import React from 'react';

import akiki from '../../../assets/Brand Center/akiki.jpg';
import americantourister from '../../../assets/Brand Center/american-tourister.jpeg';
import arctic from '../../../assets/Brand Center/arctic.jpg';
import axor from '../../../assets/Brand Center/axor.png';
import baggit from '../../../assets/Brand Center/baggit.webp';
import borosil from '../../../assets/Brand Center/brosil.jpg';
import caprese from '../../../assets/Brand Center/caprese.jpg';
import Cello from '../../../assets/Brand Center/cello.png';
import duckback from '../../../assets/Brand Center/duckback.webp';
import gear from '../../../assets/Brand Center/gear.jpg';
import kammillient from '../../../assets/Brand Center/kammillient.png';
import laOpala from '../../../assets/Brand Center/LaOpala.jpg';
import lavie from '../../../assets/Brand Center/lavie.png';
import milton from '../../../assets/Brand Center/Milton.jpg';
import Prestige from '../../../assets/Brand Center/Prestige_Brands.png';
import safari from '../../../assets/Brand Center/safari.jpg';
import skybags from '../../../assets/Brand Center/skybags.png';
import steelbird from '../../../assets/Brand Center/stellbirds.png';
import tommy from '../../../assets/Brand Center/tommy.jpg';
import vega from '../../../assets/Brand Center/vega.png';
import vip from '../../../assets/Brand Center/vip.png';
import wildcraft from '../../../assets/Brand Center/wildcraft.png';
import Zell from '../../../assets/Brand Center/Zell.png';

function BrandSlider() {
  const brands = [
    {name: 'arctic', logo: arctic},
    {name: 'American Tourister', logo: americantourister},
    {name:'akiki', logo: akiki},
    {name: 'Wildcraft', logo: wildcraft},
    {name: 'Skybag', logo: skybags},
    // {name: 'Safari', logo: safari},
    {name: 'axor', logo: axor},
    {name: 'baggit Vuitton', logo: baggit},
    {name: 'borosil', logo: borosil},
    {name: 'caprese', logo: caprese},
    {name: 'Cello', logo: Cello},
    {name: 'duckback', logo: duckback},
    {name: 'gear', logo: gear},
    {name: 'kammillient', logo: kammillient},
    {name: 'laOpala', logo: laOpala},
    {name: 'lavie', logo: lavie},
    {name: 'milton', logo: milton},
    {name: 'Prestige', logo: Prestige},
    {name: 'safari', logo: safari},
    {name: 'steelbird', logo: steelbird},
    {name: 'tommy', logo: tommy},
    {name: 'vega', logo: vega},
    {name: 'vip', logo: vip},
    {name: 'Zell', logo: Zell},
  ];

  // Duplicate the brands for continuous scrolling
  const scrollingBrands = [...brands, ...brands];

  return (
    <section className={'w-full overflow-hidden py-16 bg-transparent'}>
      <div
        className={'flex animate-scroll whitespace-nowrap'}
        style={{gap: '2rem'}}
      >
        {scrollingBrands.map((brand, i) => (
          <div
            key={i}
            className={'flex-shrink-0'}
            style={{width: 'calc(100% / 7)'}} // large screens: 7 items visible
          >
            <img
              src={brand.logo}
              alt={brand.name}
              className={'h-28 object-contain w-full'}
            />
          </div>
        ))}
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          display: flex;
          animation: scroll 10s linear infinite;
        }

        @media (max-width: 1024px) {
          .animate-scroll > div {
            width: calc(100% / 5) !important; /* mobile: 4 items visible */
          }
        }
      `}</style>
    </section>
  );
}

export default BrandSlider;
